/* eslint-disable max-lines */

export default [
  {
    code: 'GB',
    name: 'United Kingdom',
    nationality: 'British',
    isChecked: true
  },
  {
    code: 'AF',
    name: 'Afghanistan',
    nationality: 'Afghani',
    isChecked: false
  },
  {
    code: 'AL',
    name: 'Albania',
    nationality: 'Albanian',
    isChecked: false
  },
  {
    code: 'DZ',
    name: 'Algeria',
    nationality: 'Algerian',
    isChecked: false
  },
  {
    code: 'AS',
    name: 'American Samoa',
    nationality: 'Samoan',
    isChecked: false
  },
  {
    code: 'AD',
    name: 'Andorra',
    nationality: 'Andorran',
    isChecked: false
  },
  {
    code: 'AO',
    name: 'Angola',
    nationality: 'Angolan',
    isChecked: false
  },
  {
    code: 'AI',
    name: 'Anguilla',
    nationality: 'Anguillan',
    isChecked: false
  },
  {
    code: 'AQ',
    name: 'Antarctica',
    nationality: 'Antarctic',
    isChecked: false
  },
  {
    code: 'AG',
    name: 'Antigua and Barbuda',
    nationality: 'Antiguan',
    isChecked: false
  },
  {
    code: 'AR',
    name: 'Argentina',
    nationality: 'Argentine',
    isChecked: false
  },
  {
    code: 'AM',
    name: 'Armenia',
    nationality: 'Armenian',
    isChecked: false
  },
  {
    code: 'AW',
    name: 'Aruba',
    nationality: 'Arubian',
    isChecked: false
  },
  {
    code: 'AU',
    name: 'Australia',
    nationality: 'Australian',
    isChecked: false
  },
  {
    code: 'AT',
    name: 'Austria',
    nationality: 'Austrian',
    isChecked: false
  },
  {
    code: 'AZ',
    name: 'Azerbaijan',
    nationality: 'Azerbaijani',
    isChecked: false
  },
  {
    code: 'BS',
    name: 'Bahamas (the)',
    nationality: 'Bahameese',
    isChecked: false
  },
  {
    code: 'BH',
    name: 'Bahrain',
    nationality: 'Bahrainian',
    isChecked: false
  },
  {
    code: 'BD',
    name: 'Bangladesh',
    nationality: 'Bangladeshi',
    isChecked: false
  },
  {
    code: 'BB',
    name: 'Barbados',
    nationality: 'Barbadian',
    isChecked: false
  },
  {
    code: 'BY',
    name: 'Belarus',
    nationality: 'Belarusian',
    isChecked: false
  },
  {
    code: 'BE',
    name: 'Belgium',
    nationality: 'Belgian',
    isChecked: false
  },
  {
    code: 'BZ',
    name: 'Belize',
    nationality: 'Belizean',
    isChecked: false
  },
  {
    code: 'BJ',
    name: 'Benin',
    nationality: 'Beninese',
    isChecked: false
  },
  {
    code: 'BM',
    name: 'Bermuda',
    nationality: 'Bermudan',
    isChecked: false
  },
  {
    code: 'BT',
    name: 'Bhutan',
    nationality: 'Bhutanese',
    isChecked: false
  },
  {
    code: 'BO',
    name: 'Bolivia',
    nationality: 'Bolivian',
    isChecked: false
  },
  {
    code: 'BA',
    name: 'Bosnia and Herzegovina',
    nationality: 'Bosnian',
    isChecked: false
  },
  {
    code: 'BW',
    name: 'Botswana',
    nationality: 'Motswana',
    isChecked: false
  },
  {
    code: 'BV',
    name: 'Bouvet Island',
    nationality: 'Norwegian',
    isChecked: false
  },
  {
    code: 'BR',
    name: 'Brazil',
    nationality: 'Brazilian',
    isChecked: false
  },
  {
    code: 'IO',
    name: 'British Indian Ocean Territory',
    nationality: 'British',
    isChecked: false
  },
  {
    code: 'VG',
    name: 'Virgin Islands (British)',
    nationality: 'British',
    isChecked: false
  },
  {
    code: 'BN',
    name: 'Brunei Darussalam',
    nationality: 'Bruneian',
    isChecked: false
  },
  {
    code: 'BG',
    name: 'Bulgaria',
    nationality: 'Bulgarian',
    isChecked: false
  },
  {
    code: 'BF',
    name: 'Burkina Faso',
    nationality: 'Burkinabe',
    isChecked: false
  },
  {
    code: 'BI',
    name: 'Burundi',
    nationality: 'Burundian',
    isChecked: false
  },
  {
    code: 'KH',
    name: 'Cambodia',
    nationality: 'Cambodian',
    isChecked: false
  },
  {
    code: 'CM',
    name: 'Cameroon',
    nationality: 'Cameroonian',
    isChecked: false
  },
  {
    code: 'CA',
    name: 'Canada',
    nationality: 'Canadian',
    isChecked: false
  },
  {
    code: 'CV',
    name: 'Cabo Verde',
    nationality: 'Cape Verdean',
    isChecked: false
  },
  {
    code: 'KY',
    name: 'Cayman Islands (the)',
    nationality: 'Caymanian',
    isChecked: false
  },
  {
    code: 'CF',
    name: 'Central African Republic',
    nationality: 'Central Africans',
    isChecked: false
  },
  {
    code: 'TD',
    name: 'Chad',
    nationality: 'Chadian',
    isChecked: false
  },
  {
    code: 'CL',
    name: 'Chile',
    nationality: 'Chilean',
    isChecked: false
  },
  {
    code: 'CN',
    name: 'China',
    nationality: 'Chinese',
    isChecked: false
  },
  {
    code: 'CX',
    name: 'Christmas Island',
    nationality: 'Christmas Islander',
    isChecked: false
  },
  {
    code: 'CC',
    name: 'Cocos (Keeling) Islands',
    nationality: 'Cocossian',
    isChecked: false
  },
  {
    code: 'CO',
    name: 'Colombia',
    nationality: 'Colombian',
    isChecked: false
  },
  {
    code: 'KM',
    name: 'Comoros (the)',
    nationality: 'Comoran',
    isChecked: false
  },
  {
    code: 'CG',
    name: 'Congo (the)',
    nationality: 'Congolese',
    isChecked: false
  },
  {
    code: 'CK',
    name: 'Cook Islands (the)',
    nationality: 'Cook Islander',
    isChecked: false
  },
  {
    code: 'CR',
    name: 'Costa Rica',
    nationality: 'Costa Rican',
    isChecked: false
  },
  {
    code: 'HR',
    name: 'Croatia',
    nationality: 'Croatian',
    isChecked: false
  },
  {
    code: 'CU',
    name: 'Cuba',
    nationality: 'Cuban',
    isChecked: false
  },
  {
    code: 'CW',
    name: 'Curacao',
    nationality: 'Curacaoan',
    isChecked: false
  },
  {
    code: 'CY',
    name: 'Cyprus',
    nationality: 'Cypriot',
    isChecked: false
  },
  {
    code: 'CZ',
    name: 'Czechia',
    nationality: 'Czech',
    isChecked: false
  },
  {
    code: 'CI',
    name: 'Cote d"Ivoire',
    nationality: 'Ivorian',
    isChecked: false
  },
  {
    code: 'DK',
    name: 'Denmark',
    nationality: 'Danish',
    isChecked: false
  },
  {
    code: 'DJ',
    name: 'Djibouti',
    nationality: 'Djiboutian',
    isChecked: false
  },
  {
    code: 'DM',
    name: 'Dominica',
    nationality: 'Dominican',
    isChecked: false
  },
  {
    code: 'DO',
    name: 'Dominican Republic',
    nationality: 'Dominican',
    isChecked: false
  },
  {
    code: 'EC',
    name: 'Ecuador',
    nationality: 'Ecuadorean',
    isChecked: false
  },
  {
    code: 'EG',
    name: 'Egypt',
    nationality: 'Egyptian',
    isChecked: false
  },
  {
    code: 'SV',
    name: 'El Salvador',
    nationality: 'Salvadorean',
    isChecked: false
  },
  {
    code: 'GQ',
    name: 'Equatorial Guinea',
    nationality: 'Equatorial Guinean',
    isChecked: false
  },
  {
    code: 'ER',
    name: 'Eritrea',
    nationality: 'Eritrean',
    isChecked: false
  },
  {
    code: 'EE',
    name: 'Estonia',
    nationality: 'Estonian',
    isChecked: false
  },
  {
    code: 'ET',
    name: 'Ethiopia',
    nationality: 'Ethiopian',
    isChecked: false
  },
  {
    code: 'FK',
    name: 'Falkland Islands',
    nationality: 'Falkland Islander',
    isChecked: false
  },
  {
    code: 'FO',
    name: 'Faroe Islands (the)',
    nationality: 'Faroese',
    isChecked: false
  },
  {
    code: 'FJ',
    name: 'Fiji',
    nationality: 'Fijian',
    isChecked: false
  },
  {
    code: 'FI',
    name: 'Finland',
    nationality: 'Finnish',
    isChecked: false
  },
  {
    code: 'FR',
    name: 'France',
    nationality: 'French',
    isChecked: false
  },
  {
    code: 'GF',
    name: 'French Guiana',
    nationality: 'French Guianese',
    isChecked: false
  },
  {
    code: 'PF',
    name: 'French Polynesia',
    nationality: 'French Polynesian',
    isChecked: false
  },
  {
    code: 'TF',
    name: 'French Southern Territories',
    nationality: 'French',
    isChecked: false
  },
  {
    code: 'GA',
    name: 'Gabon',
    nationality: 'Gabonese',
    isChecked: false
  },
  {
    code: 'GM',
    name: 'Gambia (the)',
    nationality: 'Gambian',
    isChecked: false
  },
  {
    code: 'GE',
    name: 'Georgia',
    nationality: 'Georgian',
    isChecked: false
  },
  {
    code: 'DE',
    name: 'Germany',
    nationality: 'German',
    isChecked: false
  },
  {
    code: 'GH',
    name: 'Ghana',
    nationality: 'Ghanaian',
    isChecked: false
  },
  {
    code: 'GI',
    name: 'Gibraltar',
    nationality: 'Gibralterian',
    isChecked: false
  },
  {
    code: 'GR',
    name: 'Greece',
    nationality: 'Greek',
    isChecked: false
  },
  {
    code: 'GL',
    name: 'Greenland',
    nationality: 'Greenlander',
    isChecked: false
  },
  {
    code: 'GD',
    name: 'Grenada',
    nationality: 'Grenadian',
    isChecked: false
  },
  {
    code: 'GP',
    name: 'Guadeloupe',
    nationality: 'Guadeloupean',
    isChecked: false
  },
  {
    code: 'GU',
    name: 'Guam',
    nationality: 'Guamanian',
    isChecked: false
  },
  {
    code: 'GT',
    name: 'Guatemala',
    nationality: 'Guatemalan',
    isChecked: false
  },
  {
    code: 'GG',
    name: 'Guernsey',
    nationality: 'British',
    isChecked: false
  },
  {
    code: 'GW',
    name: 'Guinea-Bissau',
    nationality: 'Guinean',
    isChecked: false
  },
  {
    code: 'GN',
    name: 'Guinea',
    nationality: 'Guinean',
    isChecked: false
  },
  {
    code: 'GY',
    name: 'Guyana',
    nationality: 'Guyanese',
    isChecked: false
  },
  {
    code: 'HT',
    name: 'Haiti',
    nationality: 'Haitian',
    isChecked: false
  },
  {
    code: 'HM',
    name: 'Heard Island And McDonald Islands',
    nationality: 'Australian',
    isChecked: false
  },
  {
    code: 'HN',
    name: 'Honduras',
    nationality: 'Honduran',
    isChecked: false
  },
  {
    code: 'HK',
    name: 'Hong Kong',
    nationality: 'Hong Konger',
    isChecked: false
  },
  {
    code: 'HU',
    name: 'Hungary',
    nationality: 'Hungarian',
    isChecked: false
  },
  {
    code: 'IS',
    name: 'Iceland',
    nationality: 'Icelander',
    isChecked: false
  },
  {
    code: 'IN',
    name: 'India',
    nationality: 'Indian',
    isChecked: false
  },
  {
    code: 'ID',
    name: 'Indonesia',
    nationality: 'Indonesian',
    isChecked: false
  },
  {
    code: 'IR',
    name: 'Iran (Islamic Republic of)',
    nationality: 'Iranian',
    isChecked: false
  },
  {
    code: 'IQ',
    name: 'Iraq',
    nationality: 'Iraqi',
    isChecked: false
  },
  {
    code: 'IE',
    name: 'Ireland',
    nationality: 'Irish',
    isChecked: false
  },
  {
    code: 'IM',
    name: 'Isle Of Man',
    nationality: 'Manx',
    isChecked: false
  },
  {
    code: 'IL',
    name: 'Israel',
    nationality: 'Israeli',
    isChecked: false
  },
  {
    code: 'IT',
    name: 'Italy',
    nationality: 'Italian',
    isChecked: false
  },
  {
    code: 'JM',
    name: 'Jamaica',
    nationality: 'Jamaican',
    isChecked: false
  },
  {
    code: 'JP',
    name: 'Japan',
    nationality: 'Japanese',
    isChecked: false
  },
  {
    code: 'JE',
    name: 'Jersey',
    nationality: 'British',
    isChecked: false
  },
  {
    code: 'JO',
    name: 'Jordan',
    nationality: 'Jordanian',
    isChecked: false
  },
  {
    code: 'KZ',
    name: 'Kazakhstan',
    nationality: 'Kazakhstani',
    isChecked: false
  },
  {
    code: 'KE',
    name: 'Kenya',
    nationality: 'Kenyan',
    isChecked: false
  },
  {
    code: 'KI',
    name: 'Kiribati',
    nationality: 'I-Kiribati',
    isChecked: false
  },
  {
    code: 'KW',
    name: 'Kuwait',
    nationality: 'Kuwaiti',
    isChecked: false
  },
  {
    code: 'KG',
    name: 'Kyrgyzstan',
    nationality: 'Kyrgyzstani',
    isChecked: false
  },
  {
    code: 'LA',
    name: 'Laos',
    nationality: 'Laotian',
    isChecked: false
  },
  {
    code: 'LV',
    name: 'Latvia',
    nationality: 'Latvian',
    isChecked: false
  },
  {
    code: 'LB',
    name: 'Lebanon',
    nationality: 'Lebanese',
    isChecked: false
  },
  {
    code: 'LS',
    name: 'Lesotho',
    nationality: 'Mosotho',
    isChecked: false
  },
  {
    code: 'LR',
    name: 'Liberia',
    nationality: 'Liberian',
    isChecked: false
  },
  {
    code: 'LY',
    name: 'Libya',
    nationality: 'Libyan',
    isChecked: false
  },
  {
    code: 'LI',
    name: 'Liechtenstein',
    nationality: 'Liechtensteiner',
    isChecked: false
  },
  {
    code: 'LT',
    name: 'Lithuania',
    nationality: 'Lithuanian',
    isChecked: false
  },
  {
    code: 'LU',
    name: 'Luxembourg',
    nationality: 'Luxembourger',
    isChecked: false
  },
  {
    code: 'MO',
    name: 'Macau',
    nationality: 'Macanese',
    isChecked: false
  },
  {
    code: 'MK',
    name: 'Macedonia',
    nationality: 'Macedonian',
    isChecked: false
  },
  {
    code: 'MG',
    name: 'Madagascar',
    nationality: 'Malagasy',
    isChecked: false
  },
  {
    code: 'MW',
    name: 'Malawi',
    nationality: 'Malawian',
    isChecked: false
  },
  {
    code: 'MY',
    name: 'Malaysia',
    nationality: 'Malaysian',
    isChecked: false
  },
  {
    code: 'MV',
    name: 'Maldives',
    nationality: 'Maldivan',
    isChecked: false
  },
  {
    code: 'ML',
    name: 'Mali',
    nationality: 'Malian',
    isChecked: false
  },
  {
    code: 'MT',
    name: 'Malta',
    nationality: 'Maltese',
    isChecked: false
  },
  {
    code: 'MH',
    name: 'Marshall Islands',
    nationality: 'Marshallese',
    isChecked: false
  },
  {
    code: 'MQ',
    name: 'Martinique',
    nationality: 'Martinican',
    isChecked: false
  },
  {
    code: 'MR',
    name: 'Mauritania',
    nationality: 'Mauritanian',
    isChecked: false
  },
  {
    code: 'MU',
    name: 'Mauritius',
    nationality: 'Mauritian',
    isChecked: false
  },
  {
    code: 'YT',
    name: 'Mayotte',
    nationality: 'Mahoran',
    isChecked: false
  },
  {
    code: 'MX',
    name: 'Mexico',
    nationality: 'Mexican',
    isChecked: false
  },
  {
    code: 'FM',
    name: 'Micronesia',
    nationality: 'Micronesian',
    isChecked: false
  },
  {
    code: 'MD',
    name: 'Moldova (the Republic of)',
    nationality: 'Moldovan',
    isChecked: false
  },
  {
    code: 'MC',
    name: 'Monaco',
    nationality: 'Monacan',
    isChecked: false
  },
  {
    code: 'MN',
    name: 'Mongolia',
    nationality: 'Mongolian',
    isChecked: false
  },
  {
    code: 'ME',
    name: 'Montenegro',
    nationality: 'Montenegrin',
    isChecked: false
  },
  {
    code: 'MS',
    name: 'Montserrat',
    nationality: 'Montserratian',
    isChecked: false
  },
  {
    code: 'MA',
    name: 'Morocco',
    nationality: 'Moroccan',
    isChecked: false
  },
  {
    code: 'MZ',
    name: 'Mozambique',
    nationality: 'Mozambican',
    isChecked: false
  },
  {
    code: 'MM',
    name: 'Myanmar',
    nationality: 'Burmese',
    isChecked: false
  },
  {
    code: 'NA',
    name: 'Namibia',
    nationality: 'Namibian',
    isChecked: false
  },
  {
    code: 'NR',
    name: 'Nauru',
    nationality: 'Nauruan',
    isChecked: false
  },
  {
    code: 'NP',
    name: 'Nepal',
    nationality: 'Nepalese',
    isChecked: false
  },
  {
    code: 'NL',
    name: 'Netherlands (the)',
    nationality: 'Dutch',
    isChecked: false
  },
  {
    code: 'NC',
    name: 'New Caledonia',
    nationality: 'New Caledonian',
    isChecked: false
  },
  {
    code: 'NZ',
    name: 'New Zealand',
    nationality: 'New Zealander',
    isChecked: false
  },
  {
    code: 'NI',
    name: 'Nicaragua',
    nationality: 'Nicaraguan',
    isChecked: false
  },
  {
    code: 'NE',
    name: 'Niger (the)',
    nationality: 'Nigerien',
    isChecked: false
  },
  {
    code: 'NG',
    name: 'Nigeria',
    nationality: 'Nigerian',
    isChecked: false
  },
  {
    code: 'NU',
    name: 'Niue',
    nationality: 'Niuean',
    isChecked: false
  },
  {
    code: 'NF',
    name: 'Norfolk Island',
    nationality: 'Norfolk Islander',
    isChecked: false
  },
  {
    code: 'KP',
    name: 'North Korea',
    nationality: 'Korean',
    isChecked: false
  },
  {
    code: 'MP',
    name: 'Northern Mariana Islands',
    nationality: 'Northern Mariana Islander',
    isChecked: false
  },
  {
    code: 'NO',
    name: 'Norway',
    nationality: 'Norwegian',
    isChecked: false
  },
  {
    code: 'OM',
    name: 'Oman',
    nationality: 'Omani',
    isChecked: false
  },
  {
    code: 'PK',
    name: 'Pakistan',
    nationality: 'Pakistani',
    isChecked: false
  },
  {
    code: 'PW',
    name: 'Palau',
    nationality: 'Palauan',
    isChecked: false
  },
  {
    code: 'PS',
    name: 'Palestine',
    nationality: 'Palestinian',
    isChecked: false
  },
  {
    code: 'PA',
    name: 'Panama',
    nationality: 'Panamanian',
    isChecked: false
  },
  {
    code: 'PG',
    name: 'Papua New Guinea',
    nationality: 'Papua New Guinean',
    isChecked: false
  },
  {
    code: 'PY',
    name: 'Paraguay',
    nationality: 'Paraguayan',
    isChecked: false
  },
  {
    code: 'PE',
    name: 'Peru',
    nationality: 'Peruvian',
    isChecked: false
  },
  {
    code: 'PH',
    name: 'Philippines (the)',
    nationality: 'Filipino',
    isChecked: false
  },
  {
    code: 'PN',
    name: 'Pitcairn',
    nationality: 'Pitcairn Islander',
    isChecked: false
  },
  {
    code: 'PL',
    name: 'Poland',
    nationality: 'Polish',
    isChecked: false
  },
  {
    code: 'PT',
    name: 'Portugal',
    nationality: 'Portuguese',
    isChecked: false
  },
  {
    code: 'PR',
    name: 'Puerto Rico',
    nationality: 'Puerto Rican',
    isChecked: false
  },
  {
    code: 'QA',
    name: 'Qatar',
    nationality: 'Qatari',
    isChecked: false
  },
  {
    code: 'RE',
    name: 'Reunion',
    nationality: 'Reunionese',
    isChecked: false
  },
  {
    code: 'RO',
    name: 'Romania',
    nationality: 'Romanian',
    isChecked: false
  },
  {
    code: 'RU',
    name: 'Russian Federation',
    nationality: 'Russian',
    isChecked: false
  },
  {
    code: 'RW',
    name: 'Rwanda',
    nationality: 'Rwandan',
    isChecked: false
  },
  {
    code: 'BL',
    name: 'Saint Barthelemy',
    nationality: 'Barthelemois',
    isChecked: false
  },
  {
    code: 'SH',
    name: 'Saint Helena',
    nationality: 'Saint Helenian',
    isChecked: false
  },
  {
    code: 'KN',
    name: 'Saint Kitts And Nevis',
    nationality: 'Kittian',
    isChecked: false
  },
  {
    code: 'LC',
    name: 'Saint Lucia',
    nationality: 'Saint Lucian',
    isChecked: false
  },
  {
    code: 'MF',
    name: 'Saint Martin (French part)',
    nationality: 'French',
    isChecked: false
  },
  {
    code: 'PM',
    name: 'Saint Pierre And Miquelon',
    nationality: 'Saint-Pierrais',
    isChecked: false
  },
  {
    code: 'VC',
    name: 'Saint Vincent And The Grenadines',
    nationality: 'Saint Vincentian',
    isChecked: false
  },
  {
    code: 'WS',
    name: 'Samoa',
    nationality: 'Samoan',
    isChecked: false
  },
  {
    code: 'SM',
    name: 'San Marino',
    nationality: 'Sanmarinese',
    isChecked: false
  },
  {
    code: 'ST',
    name: 'Sao Tome And Principe',
    nationality: 'Sao Tomean',
    isChecked: false
  },
  {
    code: 'SA',
    name: 'Saudi Arabia',
    nationality: 'Saudi Arabian',
    isChecked: false
  },
  {
    code: 'SN',
    name: 'Senegal',
    nationality: 'Senegalese',
    isChecked: false
  },
  {
    code: 'RS',
    name: 'Serbia',
    nationality: 'Serbian',
    isChecked: false
  },
  {
    code: 'SC',
    name: 'Seychelles',
    nationality: 'Seychellois',
    isChecked: false
  },
  {
    code: 'SL',
    name: 'Sierra Leone',
    nationality: 'Sierra Leonean',
    isChecked: false
  },
  {
    code: 'SG',
    name: 'Singapore',
    nationality: 'Singaporean',
    isChecked: false
  },
  {
    code: 'SX',
    name: 'Sint Maarten (Dutch part)',
    nationality: 'Dutch',
    isChecked: false
  },
  {
    code: 'SK',
    name: 'Slovakia',
    nationality: 'Slovakian',
    isChecked: false
  },
  {
    code: 'SI',
    name: 'Slovenia',
    nationality: 'Slovenian',
    isChecked: false
  },
  {
    code: 'SB',
    name: 'Solomon Islands',
    nationality: 'Solomon Islander',
    isChecked: false
  },
  {
    code: 'SO',
    name: 'Somalia',
    nationality: 'Somali',
    isChecked: false
  },
  {
    code: 'ZA',
    name: 'South Africa',
    nationality: 'South African',
    isChecked: false
  },
  {
    code: 'GS',
    name: 'South Georgia And The South Sandwich Islands',
    nationality: 'British',
    isChecked: false
  },
  {
    code: 'SS',
    name: 'South Sudan',
    nationality: 'Sudanese',
    isChecked: false
  },
  {
    code: 'KR',
    name: 'Korea (the Republic of)',
    nationality: 'Korean',
    isChecked: false
  },
  {
    code: 'ES',
    name: 'Spain',
    nationality: 'Spanish',
    isChecked: false
  },
  {
    code: 'LK',
    name: 'Sri Lanka',
    nationality: 'Sri Lankan',
    isChecked: false
  },
  {
    code: 'SD',
    name: 'Sudan (the)',
    nationality: 'Sudanese',
    isChecked: false
  },
  {
    code: 'SR',
    name: 'Suriname',
    nationality: 'Surinamer',
    isChecked: false
  },
  {
    code: 'SJ',
    name: 'Svalbard And Jan Mayen Islands',
    nationality: 'Norwegian',
    isChecked: false
  },
  {
    code: 'SZ',
    name: 'Swaziland',
    nationality: 'Swazi',
    isChecked: false
  },
  {
    code: 'SE',
    name: 'Sweden',
    nationality: 'Swedish',
    isChecked: false
  },
  {
    code: 'CH',
    name: 'Switzerland',
    nationality: 'Swiss',
    isChecked: false
  },
  {
    code: 'SY',
    name: 'Syrian Arab Republic',
    nationality: 'Syrian',
    isChecked: false
  },
  {
    code: 'TW',
    name: 'Taiwan (Province of China)',
    nationality: 'Taiwanese',
    isChecked: false
  },
  {
    code: 'TJ',
    name: 'Tajikistan',
    nationality: 'Tajikistani',
    isChecked: false
  },
  {
    code: 'TZ',
    name: 'Tanzania, United Republic of',
    nationality: 'Tanzanian',
    isChecked: false
  },
  {
    code: 'TH',
    name: 'Thailand',
    nationality: 'Thai',
    isChecked: false
  },
  {
    code: 'CD',
    name: 'Congo (the Democratic Republic of the)',
    nationality: 'Congolese',
    isChecked: false
  },
  {
    code: 'TL',
    name: 'Timor-Leste',
    nationality: 'Timorese',
    isChecked: false
  },
  {
    code: 'TG',
    name: 'Togo',
    nationality: 'Togolese',
    isChecked: false
  },
  {
    code: 'TK',
    name: 'Tokelau',
    nationality: 'Tokelauan',
    isChecked: false
  },
  {
    code: 'TO',
    name: 'Tonga',
    nationality: 'Tongan',
    isChecked: false
  },
  {
    code: 'TT',
    name: 'Trinidad and Tobago',
    nationality: 'Trinidadian',
    isChecked: false
  },
  {
    code: 'TN',
    name: 'Tunisia',
    nationality: 'Tunisian',
    isChecked: false
  },
  {
    code: 'TR',
    name: 'Turkey',
    nationality: 'Turkish',
    isChecked: false
  },
  {
    code: 'TM',
    name: 'Turkmenistan',
    nationality: 'Turkmen',
    isChecked: false
  },
  {
    code: 'TC',
    name: 'Turks and Caicos Islands',
    nationality: 'Turks and Caicos Islander',
    isChecked: false
  },
  {
    code: 'TV',
    name: 'Tuvalu',
    nationality: 'Tuvaluan',
    isChecked: false
  },
  {
    code: 'VI',
    name: 'Virgin Islands (U.S)',
    nationality: 'Virgin Islander',
    isChecked: false
  },
  {
    code: 'UG',
    name: 'Uganda',
    nationality: 'Ugandan',
    isChecked: false
  },
  {
    code: 'UA',
    name: 'Ukraine',
    nationality: 'Ukrainian',
    isChecked: false
  },
  {
    code: 'AE',
    name: 'United Arab Emirates',
    nationality: 'Emirian',
    isChecked: false
  },
  {
    code: 'UM',
    name: 'United States Minor Outlying Islands',
    nationality: 'United States of America',
    isChecked: false
  },
  {
    code: 'US',
    name: 'United States',
    nationality: 'American',
    isChecked: false
  },
  {
    code: 'UY',
    name: 'Uruguay',
    nationality: 'Uruguayan',
    isChecked: false
  },
  {
    code: 'UZ',
    name: 'Uzbekistan',
    nationality: 'Uzbekistani',
    isChecked: false
  },
  {
    code: 'VU',
    name: 'Vanuatu',
    nationality: 'Ni-Vanuatu',
    isChecked: false
  },
  {
    code: 'VE',
    name: 'Venezuela',
    nationality: 'Venezuelan',
    isChecked: false
  },
  {
    code: 'VN',
    name: 'Vietnam',
    nationality: 'Vietnamese',
    isChecked: false
  },
  {
    code: 'WF',
    name: 'Wallis And Futuna Islands',
    nationality: 'Wallisian',
    isChecked: false
  },
  {
    code: 'EH',
    name: 'Western Sahara',
    nationality: 'Western Saharan',
    isChecked: false
  },
  {
    code: 'YE',
    name: 'Yemen',
    nationality: 'Yemeni',
    isChecked: false
  },
  {
    code: 'ZM',
    name: 'Zambia',
    nationality: 'Zambian',
    isChecked: false
  },
  {
    code: 'ZW',
    name: 'Zimbabwe',
    nationality: 'Zimbabwean',
    isChecked: false
  },
  {
    code: 'AX',
    name: 'Aland Islands',
    nationality: 'Alandic',
    isChecked: false
  }
];
